<template>
  <component :is="iconComponent" />
</template>

<script>
  import Icons from './icons'

  export default {
    name: 'BaseIcon',
    props: {
      name: {
        type: String,
        required: true,
        validator(value) {
          return Object.prototype.hasOwnProperty.call(Icons, value)
        }
      }
    },
    computed: {
      iconComponent() {
        return Icons[this.name]
      }
    }
  }
</script>
